<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-group"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="white mx-1">
        <v-row class="mt-4 ml-4">
          <v-col cols="2">
            <v-text-field
                label="Infor"
                placeholder="Enter Name, Email"
                filled
                v-model="info"
                @input="debounceInputInfo"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-menu
                class="float-left"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    clearable
                    filled
                    class="mr-3 float-left"
                    v-model="date"
                    placeholder="Select Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  @change="getItem"
                  v-model="date"
                  @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="userBySearch"
              :sort-by="['id']"
              :sort-desc="true"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
              {{ formatDate(item.created_at) }}
            </template>
            <template v-slot:item.active_to="{ item }">
              {{ formatDate(item.active_to) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item.id)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_LIST_USERS_BY_SEARCH} from "@/store/modules/users";
import { GET_LIST_PRICING} from "@/store/modules/payment";
import {debounce} from "debounce";

export default {
  name: "Users",
  data() {
    return {
      page: "Users",
      breadcrumbs: [
        {
          text: "Users",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Customer Name", value: "name"},
        {text: "Email", value: "email"},
        {text: "Date sign up", value: "created_at"},
        {text: "Date end", value: "active_to"},
        {text: "Credits", value: "credits_sum_credit"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      menu: false,
      date: '',
      info: '',
      credit: ''
    }
  },
  computed: {
    ...mapGetters({
      userBySearch: "userBySearch",
      pricing: "pricing",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_PRICING);
    this.params();

  },
  methods: {
    viewItem(id){
      this.$router.push("/users/" + id)
    },
    getItem() {
      this.replaceOrder();
      this.params();
    },

    params() {
      let params = {
        keyword: this.info,
        date:this.date,
        pricing_id: this.credit? this.credit : ''
      };
      this.$store.dispatch(GET_LIST_USERS_BY_SEARCH, params);
    },
    replaceOrder() {
      this.$router.replace({
        query: {
          keyword: this.info,
          date:this.date,
          pricing_id: this.credit? this.credit : ''
        }
      })
    },
    debounceInputInfo: debounce(function (e) {
      this.info = e;
      this.replaceOrder();
      this.params();
    }, 200),

    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
  }
}
</script>

<style scoped>

</style>